import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ShoppingBag } from 'lucide-react';
import { fileUrl } from '../lib/utils';
import { useCart } from '../contexts/CartContext';
import { toast } from '@/hooks/use-toast';

interface ProductCardProps {
  id: string | number;
  name: string;
  price: number;
  thumbnail: string;
  description?: string;
  isNew?: boolean;
}

const ProductCard = ({
  id,
  name,
  price,
  thumbnail,
  description,
  isNew,
}: ProductCardProps) => {
  const { addToCart } = useCart();
  return (
    <div className='group relative bg-card border border-border rounded-md overflow-hidden transition-all hover:shadow-lg h-full flex flex-col'>
      {isNew && (
        <Badge className='absolute top-2 left-2 md:top-3 md:left-3 z-10 bg-primary text-primary-foreground text-[10px] md:text-xs px-1.5 py-0.5 md:px-2'>
          Шинэ
        </Badge>
      )}
      <Link to={`/product/${id}`} className='block flex-shrink-0'>
        <div className='aspect-square bg-muted overflow-hidden'>
          <img
            src={fileUrl(thumbnail)}
            alt={name}
            className='w-full h-full object-cover transition-transform duration-300 group-hover:scale-105'
          />
        </div>
      </Link>

      <div className='p-2.5 md:p-4 flex flex-col flex-1'>
        <div className='flex-1'>
          <Link to={`/product/${id}`}>
            <h3 className='font-medium text-xs md:text-sm mb-1 md:mb-2 hover:text-primary transition-colors line-clamp-2 min-h-[32px] md:min-h-[40px]'>
              {name}
            </h3>
          </Link>

          {description && (
            <p className='hidden md:block text-xs text-muted-foreground mb-3 line-clamp-2'>
              {description}
            </p>
          )}
        </div>

        <div className='flex items-center justify-between mt-auto pt-1.5 md:pt-2 gap-1'>
          <span className='font-semibold text-sm md:text-lg whitespace-nowrap truncate'>
            {price.toLocaleString('mn-MN')}₮
          </span>
          <Button
            size='icon'
            className='bg-primary hover:bg-primary/90 h-7 w-7 md:h-9 md:w-auto md:px-3 flex-shrink-0'
            onClick={() => {
              addToCart(id.toString(), 1);
              toast({
                title: '✓ Амжилттай нэмэгдлээ',
                description: name,
                duration: 2000,
              });
            }}
          >
            <ShoppingBag className='h-3.5 w-3.5 md:h-4 md:w-4' />
            <span className='hidden md:inline ml-1 text-xs'>Сагсанд</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
